module.exports = __webpack_public_path__ + "static/media/aaj_favicon.f78e5455.ico";